import React from "react";
import { selectSlot } from "../../../redux/actions/datesActions";
import {
  format,
  setMinutes,
  setHours,
  setSeconds,
  setMilliseconds,
} from "date-fns";
import { connect } from "react-redux";
import styles from "./ChooseTime.style";
import { Div, Button, Text } from "@vkontakte/vkui";
import eveningImg from "../../../img/Evening.svg";
import morningImg from "../../../img/Morning.svg";
import dayImg from "../../../img/Day.svg";
import { Grid } from "styled-css-grid";

const ChooseTime = ({ slots, selectedDay, selectedSlot, selectSlot }) => {
  const morningTime = [];
  const dayTime = [];
  const eveningTime = [];
  if (!selectedDay) {
    return <></>;
  }
  const startDayInterval = new Date(
    setHours(setMinutes(setSeconds(setMilliseconds(selectedDay, 0), 0), 0), 12)
  );
  const endDayInterval = new Date(
    setHours(
      setMinutes(setSeconds(setMilliseconds(selectedDay, 999), 59), 59),
      16
    )
  );

  slots &&
    slots
      .filter((slot) => {
        return (
          new Date(slot.visitTimeISO).getDate() === new Date(selectedDay).getDate()
        );
      })
      .forEach((slot) => {
        const timeSlot = new Date(slot.visitTimeStr);
        if (timeSlot.getTime() < startDayInterval.getTime()) {
          morningTime.push(slot);
        } else if (
          timeSlot.getTime() > startDayInterval.getTime() &&
          endDayInterval.getTime() > timeSlot.getTime()
        ) {
          dayTime.push(slot);
        } else if (timeSlot.getTime() > endDayInterval.getTime()) {
          eveningTime.push(slot);
        }
      });

  const getTimeButton = (slot) => {
    return (
      <Button
        key={slot.slotId}
        onClick={() => selectSlot(slot)}
        style={selectedSlot === slot ? styles.buttonActive : styles.button}
      >
        {format(new Date(slot.visitTimeStr), "HH:mm")}
      </Button>
    );
  };
  const getIntervalBLock = (intervalImg, intervalText, intervalTime, slots) => {
    if (!slots.length) {
      return null;
    }
    return (
      <Div style={styles.flexContainer}>
        <Div style={styles.titleContainer}>
          <img
            src={intervalImg}
            style={styles.intervalImg}
            alt={"interval img"}
          />
          <Text weight={"regular"} style={styles.intervalText}>
            {intervalText}
          </Text>
          <Text weight={"regular"} style={styles.intervalText}>
            {intervalTime}
          </Text>
        </Div>
        <Grid columns={5} justifyContent={"center"} gap={"0"} rowGap="4px">
          {slots && slots.map(getTimeButton)}
        </Grid>
      </Div>
    );
  };
  return (
    <>
      <Div
        style={{
          padding: "0",
        }}
      >
        <Text weight={"semibold"} style={styles.title}>
          Время посещения
        </Text>
      </Div>
      {getIntervalBLock(morningImg, "Утро", "", morningTime)}
      {getIntervalBLock(dayImg, "День", "", dayTime)}
      {getIntervalBLock(eveningImg, "Вечер", "", eveningTime)}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    slots: state.dates.slots,
    selectedDay: state.dates.selectedDay,
    selectedSlot: state.dates.selectedSlot,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    selectSlot: (slot) => dispatch(selectSlot(slot)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChooseTime);
